module.exports = __webpack_public_path__ + "media/images/posts/wedding-room-ecf6bcdeddde78d4b4fc12e4396d597d.jpg";